export const isConvertibleToNumber = (value) => {
    return !isNaN(parseFloat(value)) && isFinite(value);
};
